export default __webpack_public_path__ + "static/media/weightmanagement.268fb033.svg";